import { ADD_STEP_COLLAPSED_STORAGE_KEY } from "@sagot/constants";
import { useState } from "react";

function readCollapsed(): ReadonlySet<string> {
  try {
    const raw = window.localStorage.getItem(ADD_STEP_COLLAPSED_STORAGE_KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === "string") : []);
  } catch {
    return new Set();
  }
}

function writeCollapsed(ids: ReadonlySet<string>): boolean {
  try {
    window.localStorage.setItem(ADD_STEP_COLLAPSED_STORAGE_KEY, JSON.stringify([...ids]));
    return true;
  } catch {
    return false;
  }
}

/** Which sections of the menu are folded. A viewer's choice, kept in this browser (private windows and blocked storage just forget it). */
export function useCollapsedSections(): { collapsed: ReadonlySet<string>; toggle: (id: string) => void } {
  const [collapsed, setCollapsed] = useState<ReadonlySet<string>>(readCollapsed);
  const toggle = (id: string) => {
    const next = new Set(collapsed);
    if (!next.delete(id)) next.add(id);
    setCollapsed(next);
    writeCollapsed(next);
  };
  return { collapsed, toggle };
}
